"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _ = require(".");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var primary = {
  background: 'primary',
  highlight: 'anakiwa',
  button: {
    primary: 'white',
    contrast: 'primary',
    accent: 'secondary'
  },
  list: {
    indent: 'secondary'
  },
  typography: {
    title: 'white',
    titleEmphasis: 'secondary',
    message: 'orangeWhite',
    paragraph: 'quarterPearlLusta',
    paragraphEmphasis: 'secondary',
    inactive: 'quarterPearlLusta',
    label: 'inactive',
    link: 'white',
    accent: 'white'
  }
};
var secondary = {
  background: 'secondary',
  highlight: 'anakiwa',
  button: {
    primary: 'primary',
    contrast: 'white',
    accent: 'white'
  },
  list: {
    indent: 'white'
  },
  typography: {
    title: 'bayOfMary',
    titleEmphasis: 'white',
    message: 'comet',
    paragraph: 'textDefault',
    paragraphEmphasis: 'bayOfMary',
    inactive: 'textInactive',
    label: 'indigo',
    link: 'primary',
    accent: 'white'
  }
};
var light = {
  background: 'lightBackground',
  highlight: 'anakiwa',
  button: {
    primary: 'primary',
    contrast: 'white',
    accent: 'secondary'
  },
  list: {
    indent: 'secondary'
  },
  typography: {
    title: 'bayOfMary',
    titleEmphasis: 'scienceBlue',
    message: 'comet',
    paragraph: 'textDefault',
    paragraphEmphasis: 'bayOfMary',
    inactive: 'textInactive',
    label: 'indigo',
    link: 'primary',
    accent: 'secondary'
  }
};

var usePalette = function usePalette() {
  var type = (0, _react.useContext)(_.PaletteContext);

  switch (type) {
    case 'primary':
      return primary;

    case 'secondary':
      return secondary;

    default:
      return light;
  }
};

__signature__(usePalette, "useContext{type}");

var _default = usePalette;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(primary, "primary", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/PaletteProvider/usePalette.tsx");
  reactHotLoader.register(secondary, "secondary", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/PaletteProvider/usePalette.tsx");
  reactHotLoader.register(light, "light", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/PaletteProvider/usePalette.tsx");
  reactHotLoader.register(usePalette, "usePalette", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/PaletteProvider/usePalette.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/PaletteProvider/usePalette.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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